<template>
  <BaseModal :id="`modalDeletePost__${post.id}`" :size="'md'" :show.sync="$show" :title="title">
    <p class="text-dark small">
      {{ subTitle }}
    </p>
    <b-alert show class="d-flex align-items-center pl-2 align-content-center" variant="danger">
      <span>
        <strong class="d-block ml-3"> {{ post.title }} </strong>
      </span>
    </b-alert>
    <p class="text-dark small">
      {{ description }}
    </p>
    <template slot="modal-footer">
      <b-button variant="link" class="btn-link-dark" @click="$show = false"> Cancel </b-button>
      <b-button variant="danger" @click="handleDelete()">
        <span v-if="!isLoading">Delete</span>
        <span v-else class="pr-2 pl-2">
          <b-spinner label="Loading..." variant="secondary" small />
        </span>
      </b-button>
    </template>
  </BaseModal>
</template>

<script>
import Post from '@/models/Post';
import BaseModal from '@/components/base-components/BaseModal';
import { notificationMixin } from '@/mixins/notificationMixin';

export default {
  components: {
    BaseModal
  },

  mixins: [notificationMixin],

  props: {
    post: {
      type: Object,
      default: null
    },

    show: {
      type: Boolean,
      default: false
    },

    title: {
      type: String,
      default: 'Delete this post'
    },

    subTitle: {
      type: String,
      default: 'Are you sure that you want to delete this post?'
    },

    description: {
      type: String,
      default: 'Click at the "Delete" button to delete this post.'
    }
  },

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    }
  },

  methods: {
    strippedString(originalString) {
      return originalString.replace(/(<([^>]+)>)/gi, '');
    },

    async handleDelete() {
      const { id } = this.post;

      try {
        this.isLoading = true;

        await Post.api().deletePost(id);

        this.$emit('emitDeletePost', id);

        this.isLoading = false;

        this.$show = false;

        this.notiSuccess('post', 'deleted');
      } catch (e) {
        if (e.message == 'Request failed with status code 400') {
          this.notiErrorDefault('Cannot delete due to MC was published');
        } else {
          this.notiError();
        }
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
